import React from 'react';
import PropTypes from 'prop-types';
import { Input, Button } from 'antd';
import { VerifyCommunityStatus } from './VerifyCommunityStatus';
import { Translate } from 'react-localize-redux';

export default class VerifyCommunity extends React.Component {
	static propTypes = {
		community: PropTypes.object,
		code: PropTypes.string,
		cancel: PropTypes.func,
		submit: PropTypes.func,
		change: PropTypes.func,
		verifyStatus: PropTypes.number,
	};

	render() {
		const props = this.props;
		const { verifyStatus, change, code, cancel, submit } = props;

		if (verifyStatus === VerifyCommunityStatus.Joined) {
			return this.renderSuccessMessage(props.community);
		}

		const joining = verifyStatus === VerifyCommunityStatus.Joining;

		return (
			<div id="access-code-verify-con">
				<Input
					className="margin-3"
					placeholder="Access code"
					onChange={change}
					value={code}
					disabled={joining}
				/>
				<Button
					onClick={cancel}
					disabled={joining}
					className="margin-3">
					<Translate id="cancel" />
				</Button>
				<Button
					onClick={submit}
					disabled={joining}
					type="primary"
					className="margin-right-5">
					<Translate id="join" />
				</Button>
				{this.renderMessage(verifyStatus)}
			</div>
		);
	}

	renderMessage(verifyStatus) {
		switch (verifyStatus) {
			case VerifyCommunityStatus.Joining:
				return (
					<span>
						<Translate id="verifying" />
						...
					</span>
				);
			case VerifyCommunityStatus.NoAccessCode:
				return (
					<span>
						<Translate id="no_access_code" />
					</span>
				);
			case VerifyCommunityStatus.InvalidAccessCode:
				return (
					<span>
						<Translate id="invalid_access_code" />
					</span>
				);
			default:
				return <span />;
		}
	}

	renderSuccessMessage(community) {
		return (
			<h4>
				<span className="icon-mark-icon color-red">&nbsp;</span>
				<Translate id="you_are_now_a_member_of" />
				&nbsp;{community.name}
			</h4>
		);
	}
}
